/* eslint-disable camelcase */
import { Body, Checkbox, dsColors, FlexBox, FormControl, Headline } from '@Backlot-Cars/archie';
import { SanitizedHtmlBody } from 'components/SanitizedHtmlBody';
import { DOCUMENT_TYPES } from 'constants/signUp';
import { isAfcOktaUser } from '../helpers';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import styled from 'styled-components';

const LabelWrapper = styled(Body)`
	a {
		color: ${dsColors.colorBrand.primary};
		font-weight: var(--fontWeightSemiBold);
	}
`;

const Label = ({ text, size }) => (
	<LabelWrapper size={size}>
		<SanitizedHtmlBody as="span" html={text} />
	</LabelWrapper>
);

const handleEvent = (e, setValue, document_type, id) => {
	const isChecked = e.target.checked;
	setValue(document_type, isChecked ? { value: true, id } : false);
};

const renderCheckbox = (policy, policyValues, setValue, errors, register, labelSize, forceRequired = false) => {
	if (!policy) return null;

	const { acceptance_required: required, checkbox_label, document_type, marketplace_document_id: id } = policy;
	if (checkbox_label && document_type) {
		const checked = policyValues.some((value) => value && value.id === id);
		return (
			<FormControl
				key={checkbox_label}
				labelPosition="right"
				labelWrap="normal"
				required={forceRequired || required}
				label={<Label text={checkbox_label} size={labelSize} />}
				formErrors={errors}
			>
				<Checkbox
					id={document_type}
					checked={checked}
					{...register(document_type, {
						onChange: (e) => handleEvent(e, setValue, document_type, id),
						onBlur: (e) => handleEvent(e, setValue, document_type, id),
					})}
				/>
			</FormControl>
		);
	}
};

const getNonSmsPolicies = (policies) =>
	policies.filter(
		(pol) =>
			pol.document_type &&
			!pol.document_type.includes('sms') &&
			pol.document_type !== DOCUMENT_TYPES.afc_privacy_policy,
	);

const getSmsPolicies = (policies) => policies.filter((pol) => pol.document_type && pol.document_type.includes('sms'));

const getAfcPrivacyPolicy = (policies) =>
	policies.find((pol) => pol.document_type && pol.document_type === DOCUMENT_TYPES.afc_privacy_policy);

const SignUpPolicies = ({
	policies,
	policyValues,
	smsPolicyCopy,
	smsLinkCopy,
	errors,
	register,
	setValue,
	syncPolicyValues = true,
}) => {
	const { query } = useRouter();

	useEffect(() => {
		if (!syncPolicyValues) return;

		policies.map(({ document_type, marketplace_document_id: id }) => {
			const checked = policyValues.some((value) => value && value.id === id);
			if (checked) {
				setValue(document_type, { value: true, id });
			}
		});
	}, [policies, policyValues, setValue, syncPolicyValues]);

	const nonSmsPolicies = getNonSmsPolicies(policies);
	const smsPolicies = getSmsPolicies(policies);
	const afcPrivacyPolicy = getAfcPrivacyPolicy(policies);

	return (
		<>
			{nonSmsPolicies.map((policy) => renderCheckbox(policy, policyValues, setValue, errors, register, 'normal'))}

			<FlexBox flexDirection="column" gap="8px">
				<FlexBox>
					<Body>{smsPolicyCopy}</Body>
				</FlexBox>
				<FlexBox>
					<Headline href="/sms_terms" target="_blank" size="H6" color={dsColors.colorBrand.primary}>
						{smsLinkCopy}
					</Headline>
				</FlexBox>
			</FlexBox>

			{smsPolicies.map((policy) => renderCheckbox(policy, policyValues, setValue, errors, register, 'normal'))}

			{isAfcOktaUser(query) &&
				renderCheckbox(afcPrivacyPolicy, policyValues, setValue, errors, register, 'smaller', true)}
		</>
	);
};

export default SignUpPolicies;
